module.exports = __webpack_public_path__ + "static/assets/facebook-logo.ffbb13f.png";